import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import translations from '../../lib/i18n/translations.json';
import AssistantExperience from '../../assistant/pages/AssistantPage.jsx';
import AssistantDashboard from './AgentSystem/AssistantDashboard.jsx';
import GlobalAIChatProvider from './AgentSystem/GlobalAIChatProvider.jsx';
import { AgentProvider } from './AgentSystem/AgentProvider.jsx';
import { ApolloProvider } from '@apollo/client';
import client from '../../lib/apolloClient';

// Thin wrapper so /succession/assistant renders the new Assistant experience
// while also supporting the global /assistant routes.
const AssistantPage = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  const branded = (props && (props.company?.branded_name || props.company?.name)) || '';

  // Extract query params from real browser URL before entering nested router
  const urlParams = new URLSearchParams(window.location.search);
  const initialPrompt = urlParams.get('q') || urlParams.get('prompt') || '';
  console.log('[AssistantPage wrapper] Real browser URL query:', window.location.search, 'initialPrompt:', initialPrompt);

  // Feature gate: render full Assistant Dashboard if ai_assistant_chat is enabled
  let useDashboard = false;
  try {
    const state = (typeof document !== 'undefined' && document.store?.getState?.()) || {};
    const userFromProps = props.current_user || {};
    const userFromStore = state.user || {};
    const companyFromProps = props.company || {};
    const companyFromStore = state.company || {};
    const user = { ...userFromProps, ...userFromStore };
    const company = { ...companyFromProps, ...companyFromStore };
    const userFeatureList = ([])
      .concat(Array.isArray(user.features) ? user.features : [])
      .concat(Array.isArray(user.feature_types) ? user.feature_types : []);
    const companyFeatureList = ([])
      .concat(Array.isArray(company.features) ? company.features : [])
      .concat(Array.isArray(company.feature_types) ? company.feature_types : []);
    useDashboard = userFeatureList.includes('ai_assistant_chat') || companyFeatureList.includes('ai_assistant_chat');
  } catch (_) {}

  const georgeCoachEnabled = props.georgeCoachEnabled || false;
  const defaultAgent = georgeCoachEnabled ? 'george_hartman_coach_agent' : 'succession_dashboard_agent';

  const DashboardWrapped = () => (
    <ApolloProvider client={client}>
      <AgentProvider>
        <GlobalAIChatProvider defaultAgent={defaultAgent}>
          <AssistantDashboard
            user={props.current_user}
            company={props.company}
            georgeCoachEnabled={georgeCoachEnabled}
          />
        </GlobalAIChatProvider>
      </AgentProvider>
    </ApolloProvider>
  );

  return (
    <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
    <BrowserRouter>
      <Switch>
        <Route exact path="/succession/assistant" render={({ location }) => {
          // Preserve query parameters when redirecting
          return <Redirect to={`/assistant${location.search}`} />;
        }} />
        <Route exact path="/assistant" render={() => (useDashboard ? <DashboardWrapped /> : <AssistantExperience initialCompanyBrandedName={branded} initialPrompt={initialPrompt} georgeCoachEnabled={georgeCoachEnabled} />)} />
        <Route exact path="/assistant/:conversationId" render={() => <AssistantExperience initialCompanyBrandedName={branded} initialPrompt={initialPrompt} georgeCoachEnabled={georgeCoachEnabled} />} />
        {/* Fallback to experience for any nested path under this mount */}
        <Route render={() => <AssistantExperience initialCompanyBrandedName={branded} initialPrompt={initialPrompt} georgeCoachEnabled={georgeCoachEnabled} />} />
      </Switch>
    </BrowserRouter>
    </IntlProvider>
  );
};

export default AssistantPage;


